export default __webpack_public_path__ + "static/GRID2022 Stock IDPs0-24 RGBlight - Simplify-01-fr-b5efde0e05e4b461f5a5156008b508e9.svg";